import * as React from 'react';
import { VerticalNav } from "./VerticalNav";

export function HamburgerNav(){

  const [isActive, setIsActive] = React.useState(false);

  const handleClick = React.useCallback(() => {
    setIsActive(!isActive);
  }, [isActive]);

  React.useEffect(() => {
      document.body.classList.toggle("lockScroll", isActive);
  }, [handleClick, isActive]);

  return(
    <>
      <div id="hamburgerNav" onClick={handleClick} className={isActive ? "active": null}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <VerticalNav isActive={isActive} handleClick={handleClick}></VerticalNav>
    </>
  )

}
